import React, { useEffect, useState } from 'react';
import WinList from '../WinList';
import { Win, WinModel } from '../types';
import './WinApp.css';
import AddWinButton from '../AddWinButton';
import { uniqueId } from '../util';

const WinApp: React.FC = () => {
  const [wins, setWins] = useState<WinModel[]>([]);
  const [displayNewBlankItem, setDisplayNewBlankItem] = useState<boolean>(false);

  const fetchWins = async () => {
    const storageValue: string = localStorage.getItem("wins") ?? "[]";
    const wins: WinModel[] = JSON.parse(storageValue);

    setWins(wins);
  }

  const addWinItem = async (newWin: Win) => {
    const storageValue: string = localStorage.getItem("wins") ?? "[]";
    const wins: WinModel[] = JSON.parse(storageValue);

    wins.unshift({id: uniqueId(), content: newWin.content, date: newWin.date});

    localStorage.setItem("wins", JSON.stringify(wins));

    fetchWins();
  }

  const deleteWinItem = async (idToBeRemoved: string) => {
    const storageValue: string = localStorage.getItem("wins") ?? "[]";
    const wins: WinModel[] = JSON.parse(storageValue);

    const removed: WinModel[] = wins.filter((item) => {
      return item.id !== idToBeRemoved;
    })

    localStorage.setItem("wins", JSON.stringify(removed));
    
    fetchWins();
  } 

  const editWinItem = async (win: WinModel) => {
    const storageValue: string = localStorage.getItem("wins") ?? "[]";
    const wins: WinModel[] = JSON.parse(storageValue);

    for (var i = 0; i < wins.length; i++) {
      if (wins[i].id === win.id) {
        wins[i] = win;
        break;
      }
    }

    localStorage.setItem("wins", JSON.stringify(wins));

    fetchWins();
  }

  useEffect(() => {
    fetchWins();
  }, []);

  return (
    <div className='main'>
      <AddWinButton setDisplayNewBlankItem={setDisplayNewBlankItem} />
      <WinList 
        wins={wins} 
        displayNewBlankItem={displayNewBlankItem} 
        setDisplayNewBlankItem={setDisplayNewBlankItem} 
        addWinItem={addWinItem}
        deleteWinItem={deleteWinItem}
        editWinItem={editWinItem} />
    </div>
  );
};

export default WinApp;
